import { createContext } from 'react';
import { PaginationHook } from '../types';

export const PaginationFilterContext = createContext<
	PaginationHook | undefined
>(undefined);

export const PaginationFilterPersonsContext = createContext<
	PaginationHook | undefined
>(undefined);
